import { v4 as uuidv4 } from 'uuid';
import { allPages } from '../../../../redux/pagesSlice';
import { selectPage } from '../../../../redux/selectedPageSlice';
import { updatePage, addPage } from '../../../../redux/pagesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { Button, ButtonGroup } from '@chakra-ui/react';

function savePage({ pages, editPageProps, dispatch, setEditPage }) {
	let uid;
	//se é um edit
	if (editPageProps.pageId) {
		uid = editPageProps.pageId;
		let page = pages.find((el) => el.pageId == uid);
		page = JSON.parse(JSON.stringify(page));
		const newPage = Object.assign(page, editPageProps);
		dispatch(updatePage(newPage));
	} else {
		uid = uuidv4();
		const newPage = {
			pageName: editPageProps.pageName ? editPageProps.pageName : 'Nova página',
			pageType: editPageProps.pageType ? editPageProps.pageType : 'custom',
			pageId: uid,
			pageDescription: editPageProps.description,
			pageData: [],
		};
		dispatch(addPage(newPage));
		dispatch(selectPage(uid));
		setEditPage();
	}
}

const EditPageBtnGroup = ({ setEditPage, editPageProps }) => {
	const pages = useSelector(allPages);
	const dispatch = useDispatch();

	return (
		<ButtonGroup d="flex" justifyContent="flex-end">
			<Button fontSize="sm" px={3} py={3} h="32px" variant="outline" onClick={() => setEditPage()}>
				Cancelar
			</Button>
			<Button
				fontSize="sm"
				px={3}
				py={3}
				h="32px"
				bg="yellow.500"
				color="white"
				onClick={() => savePage({ pages, dispatch, editPageProps, setEditPage })}
			>
				Salvar
			</Button>
		</ButtonGroup>
	);
};

export default EditPageBtnGroup;
